import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  title: {
    margin: 0,
    marginBottom: 20,
    padding: 0,
    fontSize: 30,
    fontFamily: 'NeoSansStd',
    color: theme.custom.darkBlue,
  },
  description: {
    marginBottom: 60,
    fontSize: 16,
    color: theme.custom.darkBlue,
  },
  flex: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  button: {
    minWidth: 'auto',
    padding: '6px 12px',
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    fontWeight: 600,
    color: '#fff',
    borderRadius: 29,
    textTransform: 'uppercase',
  },
  notSave: {
    background: theme.custom.darkBlue,
    '&:hover': {
      background: theme.custom.darkBlue,
      opacity: 0.7,
    },
  },
  save: {
    background: theme.custom.accept,
    '&:hover': {
      background: theme.custom.accept,
      opacity: 0.7,
    },
  },
}));
